var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIteroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_x5F_iTero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1801 762h-6v644H255V762h-7c-68 0-123 55-123 123v528c0 68 55 123 123 123h1553c68 0 124-55 124-123V885c0-67-56-123-124-123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512 1275h1026c67 0 123-55 123-123V247c0-68-56-123-123-123H512c-68 0-124 55-124 123v905c0 68 56 123 124 123zm6-1021h1013v891H518V254zM770 1795c0 72 59 131 132 131h246c72 0 131-59 131-132v-131H770v132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1285 441c-70-47-163-73-260-73-98 0-191 26-261 73-37 25-66 54-87 87a216 216 0 0 0 0 234c21 33 50 62 87 87 36 24 78 42 123 55v121l189-183-189-183v110c-19-8-36-17-52-27-56-38-65-77-65-97s9-60 65-97c49-33 118-52 190-52 71 0 140 19 189 52 56 37 65 77 65 97s-9 59-65 97c-18 12-39 22-61 30v134c49-13 94-32 132-58 37-24 66-53 87-86a216 216 0 0 0 0-234c-21-33-50-62-87-87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIteroIcon);
export default __webpack_public_path__ + "static/media/itero_icon.9a9043b2c8dfe98bd5ba800bf6e7083b.svg";
export { ForwardRef as ReactComponent };